<template>
  <div class="orders">
    <van-nav-bar fixed placeholder title="任务单"/>
    <van-tabs v-model="currentTab" sticky animated :offset-top="46">
      <van-tab v-for="(t, idx) in tabs" :key="idx" :title="t.name">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoadMore"
          >
            <div class="list-content">
              <div class="task-card" v-for="item in historyList" :key="item.id" @click="handleDetail(item)">
                <div class="card-header">
                  <div class="header-left">
                    <div class="room-name">{{ item.roomName }} - {{ item.shop_name }}</div>
                    <div class="status-badge" :class="getStatusClass(item.status)">
                      {{ item.status == 10 ? '待处理' : item.status == 20 ? '保洁中' : '已完成' }}
                    </div>
                  </div>
                  <div class="date-text">{{ item.create_time }}</div>
                </div>

                <div class="card-body">
                  <div class="info-row">
                    <van-icon name="location-o" size="16" color="#999" />
                    <div class="info-text">地址：{{ item.address }}</div>
                  </div>
                  <div class="info-row" v-if="item.create_time">
                    <van-icon name="clock-o" size="16" color="#999" />
                    <div class="info-text">退房时间：{{ item.create_time }}</div>
                  </div>
                  <div class="info-row" v-if="item.start_time_str">
                    <van-icon name="clock-o" size="16" color="#999" />
                    <div class="info-text">开始时间：{{ item.start_time_str }}</div>
                  </div>
                  <div class="info-row" v-if="item.end_time_str">
                    <van-icon name="clock-o" size="16" color="#999" />
                    <div class="info-text">完成时间：{{ item.end_time_str }}</div>
                  </div>
                  <div class="info-button" v-if="item.status == 20">
                    <van-button color="#38B00C" round type="success" size="block">继续任务</van-button>
                  </div>
                </div>

                <div class="card-divider" v-if="item.photos && item.photos.length"></div>

                <div class="card-footer" v-if="item.photos && item.photos.length">
                  <div class="footer-left">
                    <van-icon name="photo-o" size="16" color="#999" />
                    <div class="photo-count">{{ item.photos.length }}</div>
                  </div>
                  <van-icon name="arrow" size="14" color="#ccc" />
                </div>
              </div>

              <van-empty v-if="!loading && historyList.length === 0" description="暂无任务" />
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { usertasklist } from '../../api/lxz/cleaner'

export default {
  name: 'CleanerOrders',
  data() {
    return {
      currentTab: 0,
      tabs: [
        { name: '进行中', filterType: 'pending' },
        { name: '已完成', filterType: 'finished' },
        { name: '全部', filterType: 'all' }
      ],
      historyList: [],
      page: 1,
      lastPage: 1,
      pageSize: 10,
      loading: false,
      fetching: false,
      finished: false,
      refreshing: false
    }
  },
  watch: {
    currentTab() {
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    getStatusClass(status) {
      const s = String(status)
      if (s === '30') return 'green'
      if (s === '20') return 'orange'
      return 'gray'
    },
    handleDetail(item) {
      this.$router.push(`/cleanerOrder/order/${item.id}`)
    },
    async reload() {
      this.page = 1
      this.lastPage = 1
      this.pageSize = 10
      this.finished = false
      this.historyList = []
      await this.fetchTaskList(false)
    },
    async onRefresh() {
      this.refreshing = true
      await this.reload()
      this.refreshing = false
    },
    async onLoadMore() {
      await this.fetchTaskList(true)
    },
    async fetchTaskList(isLoadMore) {
      if (this.fetching) return
      if (isLoadMore && this.finished) return

      this.fetching = true
      this.loading = true
      try {
        const filterType = this.tabs[this.currentTab].filterType
        const targetPage = isLoadMore ? this.page + 1 : 1
        const res = await usertasklist({ filterType, page: targetPage })
        if (res && res.status === 200) {
          const list = res.data && res.data.list ? res.data.list : { data: [] }
          const rawData = Array.isArray(list.data) ? list.data : []
          const data = rawData.map((item) => ({
            ...item,
            roomName: item.room_name || item.roomName,
            address: item.shop_address || item.address
          }))

          if (!isLoadMore) this.historyList = data
          else this.historyList = this.historyList.concat(data)
          this.page = targetPage
          const serverLastPage = Number(list.last_page || list.lastPage || 0)
          if (serverLastPage > 0) {
            this.lastPage = serverLastPage
            this.finished = this.page >= this.lastPage
            return
          }

          if (this.pageSize <= 0 && data.length > 0) this.pageSize = data.length
          const effectivePageSize = this.pageSize > 0 ? this.pageSize : 10
          this.finished = data.length < effectivePageSize
        } else {
          this.finished = true
        }
      } catch (e) {
        this.finished = true
      } finally {
        this.loading = false
        this.fetching = false
      }
    }
  }
}
</script>

<style scoped>
.orders {
  min-height: 100vh;
  background: #f5f7fa;
}
.list-content {
  padding: 12px;
}
.task-card {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.header-left {
  display: flex;
  align-items: center;
  min-width: 0;
}
.room-name {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 210px;
}
.status-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
  flex-shrink: 0;
}
.status-badge.green {
  background: #2b9939;
}
.status-badge.orange {
  background: #ff9900;
}
.status-badge.gray {
  background: #ccc;
}
.date-text {
  font-size: 12px;
  color: #999;
  flex-shrink: 0;
}
.card-body {
  margin-bottom: 10px;
}
.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.info-button {
  display: flex;
  justify-content: flex-end;
}
.info-row:last-child {
  margin-bottom: 0;
}
.info-text {
  font-size: 13px;
  color: #666;
  margin-left: 8px;
}
.card-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 10px 0;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-left {
  display: flex;
  align-items: center;
}
.photo-count {
  font-size: 12px;
  color: #999;
  margin-left: 6px;
}
</style>
